import { call, put, select, takeLatest } from 'redux-saga/effects';
import { attributesActions as actions } from '.';
import querystring from 'qs';
import { AttributesPayload, Attributes } from './types';
import {
  selectErpSystem,
  selectLanguage,
} from 'app/features/erpSystem/slice/selectors';
import { selectAttributesData } from './selectors';
import { checkValues } from 'utils/checkValues';

export function* fetchAttributes(action) {
  const { payload }: { payload: AttributesPayload } = action;
  const { getAttributesSuccess, getAttributesFail } = actions;
  const erpSystem = yield select(selectErpSystem);
  const language = yield select(selectLanguage);
  const attributes: Attributes = yield select(selectAttributesData);

  // TODO: Remove when update of attrivutes is handeled by backend API
  // For more information see comments https://eriksdigital.atlassian.net/browse/GB-713
  const modifiedValuesPayload = attributes && checkValues(attributes, payload);

  try {
    const attributesResponse = yield call(
      fetch,
      `/gasket-configurator/api/attributes?${querystring.stringify(
        { erpSystem, lang: language, ...modifiedValuesPayload },
        { arrayFormat: 'comma' },
      )}`,
    );

    if (attributesResponse.status !== 200) {
      return yield put(getAttributesFail('failed to fetch'));
    } else {
      const attributes: Attributes = yield attributesResponse.json();

      if (!attributes) {
        return yield put(getAttributesFail('No attributes fetched'));
      }

      return yield put(getAttributesSuccess(attributes));
    }
  } catch (e) {
    yield put(getAttributesFail('failed to fetch'));
  }
}
export function* attributesSaga() {
  yield takeLatest(actions.getAttributes.type, fetchAttributes);
}
